import * as React from "react";
import { TextField } from "@mui/material";

type HTMLInputProps = React.InputHTMLAttributes<HTMLInputElement>;

const PhoneTextFieldAdapter = React.forwardRef<HTMLInputElement, HTMLInputProps>(
  (
    { value, onChange, onBlur, onFocus, name, type, placeholder, disabled, className, ...rest },
    ref
  ) => {
    return (
      <TextField
        fullWidth
        size="small"
        inputRef={ref} // forward ref to the real <input>
        value={value ?? ""}
        onChange={onChange as any} // pass through unchanged
        onBlur={onBlur as any}
        onFocus={onFocus as any}
        name={name}
        type={type ?? "tel"}
        placeholder={placeholder}
        disabled={disabled}
        inputProps={{ ...rest, className }} // let lib set inputMode, autoComplete, etc.
        sx={{ "& .MuiInputBase-input": { borderRadius: 1, backgroundColor: "white" } }}
      />
    );
  }
);
export default PhoneTextFieldAdapter;
